import PlantixCPProducts from "./PlantixCPProducts"

export default PlantixCPProducts